module.exports = __webpack_public_path__ + "static/media/collapse_vendor_trace.b9c06bbc.svg";